import version from './version-info';
import * as transxConfig from './transx-environments';

export const environment = {
  production: false,
  environmentDefault: 'preprod',
  environments: transxConfig.environments,
  tenant: transxConfig.tenant,
  version,
};